// extracted by mini-css-extract-plugin
module.exports = {"action-buttons":"contract-views_action-buttons__1Q7Ts","back-info-message":"contract-views_back-info-message__3iC41"};